module.exports = __webpack_public_path__ + "img/step2.3d68fb54.png";